"use client";

import { create } from "zustand";

/**
 * Whether the recipient wizard holds an unsent draft, for surfaces outside it.
 *
 * BeneficiaryProvider sets it while the draft has entries and clears it on
 * unmount; the header's account switcher reads it to ask before leaving.
 *
 * Deliberately a flag and not the draft, and deliberately NOT persisted: the
 * draft carries bank details and home addresses, and a refresh, deep link or
 * duplicated tab must start clean (behind the browser's unload prompt).
 */
type RecipientDraftStore = {
  isDirty: boolean;
  setDirty: (isDirty: boolean) => void;
};

export const useRecipientDraftStore = create<RecipientDraftStore>()((set) => ({
  isDirty: false,
  setDirty: (isDirty) => set({ isDirty }),
}));
